import { NextSeo } from "next-seo";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { LoginPage } from "@nju/feature-portal-login";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function Login() {
  return (
    <LayoutWrapper>
      <NextSeo
        nofollow={true}
        noindex={true}
        title="logowanie do konta nju | nju.pl"
      />
      <Header />
      <BlockContent grid="extraWide">
        <ClientSideOnly>
          <LoginPage />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
